ui-bank-search-map {
  display: block;
  width: 100%;
  height: 100%;

  .sr-only {
    @include sr-only;
  }

  // disable fullscreen and zoom controls on mobile
  .gmnoprint.gm-bundled-control-on-bottom,
  .gm-control-active .gm-fullscreen-control {
    display: none;
  }

  @include breakpoint($desktop) {
    height: var(--map-height-desktop);

    .gmnoprint.gm-bundled-control-on-bottom,
    .gm-control-active .gm-fullscreen-control {
      display: block;
    }
  }
}
